import loadResource from '../../resource/loadResource';
import FlowerObject from '../object/FlowerObject';
import ContainerObject from '../object/ContainerObject';
import renderReal from '../../render/renderReal';
import ReomveCommand from './ReomveCommand'
class AddItemCommand {
    constructor(params, env) {
        this.params = params;
        this.env = env;
        this.id = null;
        this.prevNeedAdd = false;
        this.containChange = true;
    }
    async do () {
        //查询资源缓存若有则是直接使用，若没有则加载网络资源
        if (!this.env.resource[this.params.resourceId]) {
            this.env.resource[this.params.resourceId] = await loadResource(this.params.resourceId);
        }
        const resource = this.env.resource[this.params.resourceId];
        if (resource.type === 1) {

            //查询是否有限制，有限制则不允许添加
            let limit = sessionStorage.getItem('limit');
            if (limit) {
                limit = JSON.parse(limit);
                let appointLimitCount
                try {
                    appointLimitCount = limit.find(item => {
                        return item.materialId === this.params.resourceId
                    }).count
                } catch (error) {
                    appointLimitCount = 999;
                }

                let length = this.env.objects.flowers.filter(item => {
                    return item.resource.id === this.params.resourceId;
                }).length
                if (length >= appointLimitCount) {
                    //添加容器
                    if (this.env.listener['error']) {
                        this.env.listener['error']({
                            msg: '素材已到达上限，无法添加'
                        });
                    }
                    return;
                }
            }

            const flowerParams = JSON.parse(JSON.stringify(this.params.params || {}));
            if (this.env.isStudioMode && this.env.isStudioMode()) {
                const activeContainer = this.env.getActiveContainer && this.env.getActiveContainer();
                if (activeContainer && !flowerParams.containerId) {
                    flowerParams.containerId = activeContainer.id;
                }
                const bindContainer = this.env.getContainerById && this.env.getContainerById(flowerParams.containerId);
                if (bindContainer && this.env.getContainerGroupId) {
                    flowerParams.groupId = this.env.getContainerGroupId(bindContainer);
                }
            }

            const flowerObject = new FlowerObject({
                resource,
                id: this.params.id || this.id,
                env: this.env,
                position: this.params.position,
                params: flowerParams
            })
            this.env.objects.flowers.push(flowerObject);
            if (flowerObject.initPromise) {
                try {
                    await flowerObject.initPromise;
                } catch (error) {
                    flowerObject.remove();
                    if (this.env.listener['error']) {
                        this.env.listener['error']({
                            msg: `花材加载失败：${error && error.message ? error.message : '未知错误'}`
                        });
                    }
                    throw error;
                }
            }
            this.id = flowerObject.id;
            if (!this.env.progressiveLoading) {
                this.env.syncLayerState();
            }
        } else {

            let sourceContainer = this.env.objects.container;
            if (!this.env.isStudioMode || !this.env.isStudioMode()) {
                if (sourceContainer) {
                    this.id = sourceContainer.id;
                    sourceContainer.remove();
                    this.prevNeedAdd = true;
                    if (this.env.listener['container-add']) {
                        this.env.listener['container-add'](null);
                    }
                }
            }
            const containerPosition = this.params.position
                || (this.env.getNextContainerPosition ? this.env.getNextContainerPosition() : null);
            const containerParams = {
                ...(this.params.params || {})
            };
            const isGlbContainer = !!resource.modelFilePath;
            if (
                isGlbContainer
                && !Object.prototype.hasOwnProperty.call(containerParams, 'containerLight')
            ) {
                containerParams.containerLight = true;
            }
            const containerObject = new ContainerObject({
                resource,
                env: this.env,
                id: this.params.id || this.id,
                params: containerParams,
                position: containerPosition,
                rotation: this.params.rotation,
                glbScaleMode: this.params.glbScaleMode
            })
            try {
                await containerObject.initPromise;
            } catch (error) {
                console.error('GLB container load failed:', error);
                if (this.env.listener['error']) {
                    this.env.listener['error']({
                        msg: `容器加载失败：${error && error.message ? error.message : '未知错误'}`
                    });
                }
                throw error;
            }
            if (this.env.isStudioMode && this.env.isStudioMode()) {
                this.env.objects.containers.push(containerObject);
                this.env.objects.container = containerObject;
                this.env.selectedContainerId = containerObject.id;
            } else {
                this.env.objects.container = containerObject;
                this.env.objects.containers = [containerObject];
                this.env.selectedContainerId = containerObject.id;
            }
            if (this.env.params.render.containerLight || containerObject.params.containerLight) {
                containerObject.setLightEnhance(true);
            }
            this.id = containerObject.id;
            //添加容器
            if (this.env.listener['container-add']) {
                this.env.listener['container-add'](
                    this.env.getContainerEventPayload
                        ? this.env.getContainerEventPayload(containerObject)
                        : {
                            id: this.id,
                            radius: containerObject.radius,
                            height: containerObject.height,
                            containerLight: this.env.params.render.containerLight,
                            params: containerObject.params
                        }
                );
            }
            if (this.env.listener['studio-containers-change']) {
                this.env.listener['studio-containers-change'](this.env.getContainerLayers ? this.env.getContainerLayers() : []);
            }
            if (this.env.syncLayerState && !this.env.progressiveLoading) {
                this.env.syncLayerState();
            }

        }
        if (!this.env.progressiveLoading) {
            renderReal(this.env);
        }

        return this.id;
    }
    prev () {
        new ReomveCommand(this.id, this.env).do();
        if (this.prevNeedAdd) {
            new AddItemCommand({ ...this.params, id: this.id }, this.env).do()
        }
    }
}

export default AddItemCommand;
